document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('getInTouchTrigger');
  const content = document.getElementById('getInTouchContent');
  const container = document.getElementById('getInTouch');
  const clockIcon = document.getElementById('mobile-clock-icon');
  const accordionContainer = document.querySelector<HTMLElement>('.accordion-container');

  if (trigger && content) {
    const toggleAccordion = (): void => {
      content.classList.toggle('is-open');

      const isOpen = content.classList.contains('is-open');
      trigger.setAttribute('aria-expanded', String(isOpen));

      if (isOpen) {
        const accountItems = document.querySelectorAll<HTMLElement>('.my-account-button-items');
        accountItems.forEach((item) => {
          item.classList.remove('is-open');
        });
        const accountToggles = document.querySelectorAll<HTMLElement>('.js-account-toggle');
        accountToggles.forEach((toggle) => {
          toggle.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    };

    trigger.addEventListener('click', (e: Event) => {
      e.preventDefault();
      toggleAccordion();
    });

    trigger.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion();
      }
    });
  }

  if (clockIcon && accordionContainer) {
    clockIcon.addEventListener('click', (e: Event) => {
      e.preventDefault();
      accordionContainer.classList.toggle('is-open');
      const isOpen = accordionContainer.classList.contains('is-open');
      clockIcon.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.addEventListener('click', (e: Event) => {
    const target = e.target as HTMLElement;

    if (container && !container.contains(target)) {
      if (content?.classList.contains('is-open')) {
        content.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
      }

      const openingTimesParent = document.querySelector('.opening-times');
      const openingTimesDetails = document.querySelector('.opening-times-details');

      if (openingTimesParent) {
        openingTimesParent.classList.remove('active');
      }
      if (openingTimesDetails) {
        openingTimesDetails.classList.remove('is-open');
      }
    }

    if (accordionContainer &&
        clockIcon &&
        !accordionContainer.contains(target) &&
        !clockIcon.contains(target)) {
      accordionContainer.classList.remove('is-open');
      clockIcon.setAttribute('aria-expanded', 'false');
    }
  });
});
